import { Box, Button, useTheme } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { changePeriod } from '../../../store/actions/dashboard';
import { useTranslation } from 'react-i18next';

const width = 300;
const currentYear = new Date().getFullYear();
const PeriodSelection: React.FC = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const selectedPeriod = useAppSelector(state => state.dashboard.selectedPeriod);

    const onPeriodClick = (year: number) =>{
        dispatch(changePeriod(year));
    }

    if (selectedPeriod === undefined){
        return <></>
    } 

    return <></>; //Deactivated on demand of customer

    // return <foreignObject x={-width / 2} y="0" width={width} height="50" className='fadein-content'>
    //     <Box display={"flex"} width="100%" justifyContent={"center"}>
    //         <Box display={"flex"} bgcolor={theme.palette.primary.light} height={"30px"} borderRadius={"15px"}>
    //             {[0,1,2,3].map((year) => 
    //                 <Button key={year} sx={{
    //                     width: "69.75px",
    //                     height: "100%",
    //                     borderRadius:"15px",
    //                     color: (selectedPeriod === year ? theme.palette.primary.contrastText : theme.typography.body1.color),
    //                     backgroundColor: (selectedPeriod === year ? theme.palette.primary.dark : undefined),
    //                     fontWeight: (selectedPeriod === year ? "700" : "500s")
    //                 }} onClick={() => onPeriodClick(year)}>{year !== 3 ? (currentYear + year - 2) : t('DashboardPortfolioAll')}</Button>
    //             )}
    //         </Box>
    //     </Box>
    // </foreignObject>
}

export default PeriodSelection;